// Store
import { createSlice } from "@reduxjs/toolkit";
import { customAsyncThunk } from "store/slice/slices.functions";

// Services
import { UserOrgs, UserOrgsResponse, getUsersOrgs } from "services";

// Types
import { RootState } from "app/store";
import { RequestInfo } from "store/slice/store.types";
import { Pagination } from "types/global";

export type TUserOrganizationsSlice = {
    status: RequestInfo;
    data: UserOrgs[];
    pagination: Pagination;
};

const initialState: TUserOrganizationsSlice = {
    status: "pristine",
    data: [],
    pagination: {} as Pagination,
};

export const fetchUserOrgsThunk = customAsyncThunk<UserOrgsResponse, void>(
    "sysadmin/userOrgs/fetch",
    async (_, { getState }) => {
        const {
            sysadmin: { userOrgs },
        } = getState();

        if (userOrgs.data.length) {
            return {
                results: userOrgs.data,
                meta: userOrgs.pagination,
            };
        } else {
            const { data } = await getUsersOrgs();
            return data;
        }
    }
);

const userOrganizationsSlice = createSlice({
    name: "sysadmin/userOrgs",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchUserOrgsThunk.pending, (state) => ({
            ...state,
            status: "fetching",
        }));
        builder.addCase(fetchUserOrgsThunk.rejected, (state) => ({
            ...state,
            status: "error",
        }));
        builder.addCase(fetchUserOrgsThunk.fulfilled, (state, action) => ({
            data: action.payload.results,
            pagination: action.payload.meta,
            status: "done",
        }));
    },
});

export const getUserOrgs = (store: RootState) => store.sysadmin.userOrgs;

export default userOrganizationsSlice.reducer;
